import EditDefinition from "../../../../components/DataCollection/Unifier/UniqueDefinitions/EditDefinition/EditDefinition"


const EditDefinitionScreen = () => {
  return (
    <>
     <EditDefinition/>
    </>
  )
}

export default EditDefinitionScreen